import { useAuth } from "../../../context";
import { useQuery } from "react-query";
import { DashboardApi } from "../../../api/dashboard";
import { SupplierQuestionnaire } from "../../../api";

export const dashboardKeys = {
  all: () => ["dashboard"],
  comparison: () => ["emissionsDataComparison"],
  summary: () => ["supplierQuestionnairesSummary"]
};

export function useGetEmissionsDataComparison(config) {
  const { callApi } = useAuth();

  return useQuery(dashboardKeys.comparison(),
    () => callApi(DashboardApi.getEmissionsDataComparison), config);
}

export function useGetSupplierQuestionnairesSummary(queryParams, config) {
  const { callApi } = useAuth();
  return useQuery([...dashboardKeys.summary(), queryParams],
    () => callApi(SupplierQuestionnaire.getSupplierQuestionnairesSummary, queryParams), config);
}